module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_8023.0ba9ba5b.png";